module.exports = __webpack_public_path__ + "img/158.bdc22d9c.png";